import React from 'react'
import PropTypes from 'prop-types'
import { Text } from '@jisr-hr/design-system'

const DataTextField = ({ title, text, style }) => (
  <div style={style}>
    <Text
      color="var(--color-natural-gray-darker-1)"
      typography="caption12"
      weight="bold"
    >
      {title}
    </Text>
    <Text typography="paragraph14">{text}</Text>
  </div>
)

DataTextField.propTypes = {
  title: PropTypes.string,
  style: PropTypes.shape(),
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.node]),
}

export default DataTextField
